export default __webpack_public_path__ + "static/media/pogprizeentries.f898792c.png";